export const SITE_TITLE = 'LuxAI ADMIN App'

export const USER_STATE = {
  PERMANENT_DELETED: 'permanent_deleted',
  ARCHIVE_DELETED: 'deleted',
  ARCHIVED: 'archived',
  ACTIVE: 'active',
  ON_HOLD: 'on_hold',
  EXCLUDED: 'excluded',
  INVITED: 'invited',
  INVITE_FAILED: 'invite_failed',
  INVITE_DELIVERED: 'invite_delivered',
  LOCKED: 'locked',
}

export const USER_ROLE = {
  ACCOUNT_ADMIN: 'account_admin',
  ADMIN: 'admin',
  USER: 'user',
  ASSISTANT: 'assistant',
  PARENT: 'parent',
  OPERATION: 'operation',
  SUPER_ADMIN: 'super_admin',
}

export const ENTITY_TYPE = {
  USER: 'User',
  ACCOUNT: 'Account',
  LEARNER: 'Learner',
  GOAL: 'Goal',
  SUBSCRIPTION: 'Subscription',
}

export const ENTITY_ACTION = {
  CREATE: 'Create',
  UPDATE: 'Update',
  DELETE: 'Delete',
  LOGIN: 'Login',
  ASSIGN: 'Assign',
  UNASSIGN: 'Unassign',
  INVITE: 'Invite',
  EXPORT: 'Export',
}

export const LOCAL_STORAGE_KEYS = ['userEmail', 'msalB2CId', 'UserId', 'AccountId', 'msalClientId', 'msalClientUrl', 'apiUrl', 'hasShownPrivacyPopup', 'multiAccounts']
export const ACCOUNT_CHANGE_KEYS = ['AccountId', 'UserId']

export const USER_JOURNEY = {
  ONBOARDING: 'on_boarding',
  FILLING_PLACEMENT: 'filling_placement',
}

export const POLL_STATUS = {
  NOT_INTRODUCED: 'not_introduced',
  IN_PROGRESS: 'in_progress',
  COMPLETED: 'completed',
  SKIPPED: 'skipped',
  POSTPONED: 'postponed',
}
